(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awwwards-distributors"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializedAttribute = 'data-distributors-initialized';

    const normalize = (value) => value.toLowerCase().trim();

    const initSection = (section) => {
      if (!section || section.hasAttribute(initializedAttribute)) {
        return;
      }

      const searchInput = section.querySelector('[data-distributor-search]');
      const locationSelect = section.querySelector('[data-distributor-location]');
      const cards = Array.from(section.querySelectorAll('[data-distributor-card]'));
      const count = section.querySelector('[data-distributor-results-count]');
      const emptyState = section.querySelector('[data-distributor-empty]');

      if (!searchInput || !locationSelect || cards.length === 0 || !count || !emptyState) {
        return;
      }

      const applyFilters = () => {
        const searchValue = normalize(searchInput.value);
        const locationValue = locationSelect.value;
        let visibleCount = 0;

        cards.forEach((card) => {
          const matchesLocation = locationValue === '' || card.dataset.location === locationValue;
          const matchesSearch = searchValue === '' || (card.dataset.search || '').includes(searchValue);
          const isVisible = matchesLocation && matchesSearch;

          card.hidden = !isVisible;

          if (isVisible) {
            visibleCount += 1;
          }
        });

        count.textContent = String(visibleCount);
        emptyState.hidden = visibleCount !== 0;
      };

      searchInput.addEventListener('input', applyFilters);
      searchInput.addEventListener('search', applyFilters);
      locationSelect.addEventListener('change', applyFilters);
      section.setAttribute(initializedAttribute, '');
      applyFilters();
    };

    const initAllSections = (scope = document) => {
      scope.querySelectorAll('[data-distributors-section]').forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllSections(), { once: true });
    } else {
      initAllSections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAllSections(event.target);
    });

    document.addEventListener('shopify:section:reorder', () => {
      initAllSections();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content-tabs"] && !Shopify.designMode) return;
  try {
    
const initProductContentTabs = () => {
  document.querySelectorAll('.pct-section').forEach((section) => {
  if (section.dataset.productTabsInitialized === 'true') return;
  section.dataset.productTabsInitialized = 'true';

  const source = section.querySelector('.pct-source');
  const nav = section.querySelector('.pct-nav');
  const panels = section.querySelector('.pct-panels');
  const navLine = section.querySelector('.pct-nav-line');

  if (!source || !nav || !panels) return;

  // Parse description HTML into sections
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = source.innerHTML;

  const tabs = [];
  let currentTab = { label: 'Description', content: '' };

  Array.from(tempDiv.childNodes).forEach(node => {
    if (node.nodeType === 1 && node.tagName === 'H3') {
      // Save current tab and start a new one
      if (currentTab.content.trim()) {
        tabs.push({ ...currentTab });
      }
      currentTab = { label: node.textContent.trim(), content: '' };
    } else {
      if (node.nodeType === 1) {
        currentTab.content += node.outerHTML;
      } else if (node.nodeType === 3 && node.textContent.trim()) {
        currentTab.content += node.textContent;
      }
    }
  });
  if (currentTab.content.trim()) {
    tabs.push(currentTab);
  }

  if (tabs.length === 0 || (tabs.length === 1 && tabs[0].label === 'Description' && !tabs[0].content.trim())) {
    section.style.display = 'none';
    return;
  }

  if (tabs.length === 1 && tabs[0].label === 'Description') {
    section.style.display = '';
    section.querySelector('.pct-nav-wrapper')?.remove();
    panels.innerHTML = `<div class="pct-panel pct-active" role="tabpanel">${tabs[0].content}</div>`;
    section.removeAttribute('aria-hidden');
    return;
  }

  // Build tab navigation
  tabs.forEach((tab, i) => {
    const btn = document.createElement('button');
    const tabId = `${section.id}-tab-${i}`;
    const panelId = `${section.id}-panel-${i}`;
    btn.className = 'pct-tab-btn';
    btn.setAttribute('role', 'tab');
    btn.id = tabId;
    btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
    btn.setAttribute('aria-controls', panelId);
    btn.setAttribute('data-index', i);
    btn.textContent = tab.label;
    nav.appendChild(btn);
  });

  // Build tab panels with enhanced rendering
  tabs.forEach((tab, i) => {
    const panel = document.createElement('div');
    panel.className = 'pct-panel' + (i === 0 ? ' pct-active' : '');
    panel.id = `${section.id}-panel-${i}`;
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-labelledby', `${section.id}-tab-${i}`);

    const label = tab.label.toLowerCase();

    if (label === 'description') {
      panel.innerHTML = `<div class="pct-desc-intro">${tab.content}</div>`;
    } else if (label.includes('feature') || label.includes('benefit')) {
      panel.innerHTML = renderFeatures(tab.content);
    } else if (label.includes('how to') || label.includes('how to apply')) {
      panel.innerHTML = renderSteps(tab.content);
    } else if (label.includes('primary ingredient')) {
      panel.innerHTML = `<div class="pct-primary-ingredients">${tab.content}</div>`;
    } else if (label.includes('ingredient')) {
      panel.innerHTML = renderIngredients(tab.content);
    } else {
      panel.innerHTML = tab.content;
    }

    panels.appendChild(panel);
  });

  // Position nav line on first tab
  requestAnimationFrame(() => {
    updateNavLine(0);
  });

  // Tab switching
  nav.addEventListener('click', (e) => {
    const btn = e.target.closest('.pct-tab-btn');
    if (!btn) return;

    const index = parseInt(btn.dataset.index);

    // Update buttons
    nav.querySelectorAll('.pct-tab-btn').forEach(b => b.setAttribute('aria-selected', 'false'));
    btn.setAttribute('aria-selected', 'true');

    // Update panels
    panels.querySelectorAll('.pct-panel').forEach(p => p.classList.remove('pct-active'));
    const targetPanel = panels.querySelector(`#${section.id}-panel-${index}`);
    if (targetPanel) {
      targetPanel.classList.remove('pct-active');
      // Force re-trigger animation
      void targetPanel.offsetWidth;
      targetPanel.classList.add('pct-active');

      // Reveal items with stagger
      const items = targetPanel.querySelectorAll('.pct-feature-item, .pct-step');
      items.forEach((item, j) => {
        item.classList.remove('pct-revealed');
        setTimeout(() => item.classList.add('pct-revealed'), j * 80);
      });
    }

    updateNavLine(index);
  });

  // Auto-reveal first panel items
  const firstPanel = panels.querySelector('.pct-panel.pct-active');
  if (firstPanel) {
    const items = firstPanel.querySelectorAll('.pct-feature-item, .pct-step');
    items.forEach((item, j) => {
      setTimeout(() => item.classList.add('pct-revealed'), 200 + j * 80);
    });
  }

  // Trim product description in sidebar
  trimSidebarDescription();

  // ───── Helper functions ─────

  function updateNavLine(index) {
    const btn = nav.querySelectorAll('.pct-tab-btn')[index];
    if (!btn || !navLine) return;
    const navRect = nav.getBoundingClientRect();
    const btnRect = btn.getBoundingClientRect();
    navLine.style.left = (btnRect.left - navRect.left) + 'px';
    navLine.style.width = btnRect.width + 'px';
  }

  function renderFeatures(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const items = tmp.querySelectorAll('li');
    if (items.length === 0) return html;

    let beforeUl = '';
    // Get any <p> tags before the <ul>
    const pTags = tmp.querySelectorAll('p');
    pTags.forEach(p => { beforeUl += p.outerHTML; });

    let out = beforeUl + '<div class="pct-features-grid">';
    items.forEach(li => {
      out += `
        <div class="pct-feature-item">
          <svg class="pct-feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="pct-feature-text">${li.innerHTML}</span>
        </div>`;
    });
    out += '</div>';
    return out;
  }

  function renderSteps(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const items = tmp.querySelectorAll('li');

    let beforeOl = '';
    let afterOl = '';
    let foundOl = false;
    Array.from(tmp.children).forEach(child => {
      if (child.tagName === 'OL' || child.tagName === 'UL') {
        foundOl = true;
      } else if (!foundOl) {
        beforeOl += child.outerHTML;
      } else {
        afterOl += child.outerHTML;
      }
    });

    if (items.length === 0) return html;

    let out = beforeOl + '<div class="pct-steps">';
    items.forEach((li, idx) => {
      const strong = li.querySelector('strong');
      const title = strong ? strong.textContent : '';
      let desc = li.innerHTML;
      if (strong) {
        desc = desc.replace(strong.outerHTML, '').replace(/^[\s—–-]+/, '');
      }
      out += `
        <div class="pct-step">
          <div class="pct-step-num">${String(idx + 1).padStart(2, '0')}</div>
          <div class="pct-step-content">
            ${title ? `<div class="pct-step-title">${title}</div>` : ''}
            <div class="pct-step-desc">${desc.trim()}</div>
          </div>
        </div>`;
    });
    out += '</div>';

    // Check for pro tip
    if (afterOl) {
      const proTip = afterOl.toLowerCase().includes('pro tip');
      if (proTip) {
        out += `<div class="pct-pro-tip">${afterOl}</div>`;
      } else {
        out += afterOl;
      }
    }

    return out;
  }

  function renderIngredients(html) {
    return `<div class="pct-ingredients-text">${html}</div>`;
  }

  function trimSidebarDescription() {
    try {
      const productInfo = document.querySelector('.product-information, [class*="product-info"], [class*="ProductInfo"]');
      if (!productInfo || !productInfo.querySelector('h3')) return;

      const descBlocks = productInfo.querySelectorAll('[class*="description"], [class*="rte"], .rte');
      descBlocks.forEach(block => {
        let hide = false;
        Array.from(block.children).forEach(child => {
          if (child.tagName === 'H3') {
            hide = true;
          }
          if (hide) {
            child.style.display = 'none';
          }
        });
      });
    } catch (e) {
      // Silently fail if DOM structure differs
    }
  }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductContentTabs, { once: true });
} else {
  initProductContentTabs();
}

document.addEventListener('shopify:section:load', initProductContentTabs);

  } catch(e) { console.error(e); }
})();
})();
